import React, { useState, useEffect } from 'react';
import {Filter, ItemsStorageService} from "./filtering/itemsStorageService";
import Checkbox from "../components/Checkbox";

interface FiltersListItemCheckboxProps {
    itemsStorageService: ItemsStorageService,
    filterData: Filter,
}

const FiltersListItemCheckbox = ({ itemsStorageService, filterData }: FiltersListItemCheckboxProps) => {
    const [inputValue, setInputValue] = useState <boolean> (false);

    const changeFilterValue = (checked: boolean) => {
        itemsStorageService.setCheckedFilterValue(filterData.filterName, checked);
        setInputValue(checked);
    };

    const getCurrentFilterValue = () => {
        const filter = itemsStorageService.getCurrentFilters().find(it => it.filterName === filterData.filterName && it.filterGroupName === filterData.filterGroupName);
        if (filter) {
            setInputValue(filter.value);
        }
    };

    useEffect(() => {
        itemsStorageService.registerFiltersChangingObserver(getCurrentFilterValue);
        getCurrentFilterValue();
        return () => itemsStorageService.unRegisterFiltersChangingObserver(getCurrentFilterValue);
    }, []);

    return (
        <label key={filterData.filterName + inputValue} className="block__content product__dropdown-label">
            <Checkbox checked={inputValue} handleChecked={changeFilterValue} />
            <span className="product__dropdown-subtitle product__dropdown-text">
                {filterData.filterTitle}
            </span>
        </label>
    );
};

export default FiltersListItemCheckbox;
